export default __webpack_public_path__ + "static/media/link_media.59e63a6b.svg";